import { Category } from "@types";
import { Button, Modal, Popconfirm, Space } from "antd";
import { HelpCircle, Pencil, Trash2 } from "lucide-react";
import { CategoryForm } from "@components";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useDeleteCategory } from "@hooks";

interface Props {
  category: Category;
}

export const CategoriesTableActions = ({ category }: Props) => {
  const {t} = useTranslation();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const deleteCategory = useDeleteCategory();

  return (
    <Space>
      <Button id={`edit-${category.name}`} onClick={() => setIsModalOpen(true)} icon={<Pencil />} />
      <Popconfirm
        title={t("forms.category.deleteCategory")}
        description={t("forms.category.deleteDesc")}
        onConfirm={() => deleteCategory.mutate(category.id)}
        okButtonProps={{loading: deleteCategory.isPending}}
        icon={<HelpCircle style={{ color: "red", marginRight: 8 }} />}
      >
        <Button id={`delete-${category.name}`} danger icon={<Trash2 />} />
      </Popconfirm>

      <Modal
        title={t("forms.category.editCategory")}
        onCancel={() => setIsModalOpen(false)}
        open={isModalOpen}
        footer={null}
        destroyOnClose
      >
        <CategoryForm setIsModalOpen={setIsModalOpen} category={category} />
      </Modal>
    </Space>
  );
};
